import React from "react";
import OurPackages from "../components/OurPackages";

const Packages = () => {
  return (
    <div>
      <OurPackages />
    </div>
  );
};

export default Packages;
